export default __webpack_public_path__ + "static/marissa proctor-22059935fc04e8fff1c0ff4f5b99a4ed.png";